import { apiClient as api } from './api';
import { callV3, type ApiResponse } from '../api/envelope';
import type { AgentExecutionRequest, AgentExecutionResponse } from '../domain';

const BASE = '/api/v3/agents';

/** Lightweight agent summary surface — mirrors `AgentSummary` on the BE
 *  (`AgentsV3Controller`). Studios reference agents by id; the FE
 *  resolves the surrounding name + description via `AgentService.get`. */
export interface AgentSummary {
  id: string;
  name: string;
  description: string;
}

export interface AgentsListResponse {
  agents: AgentSummary[];
}

export const AgentService = {
  list: () => callV3<AgentsListResponse>(api.get<ApiResponse<AgentsListResponse>>(BASE)),
  get: (agentId: string) =>
    callV3<AgentSummary>(api.get<ApiResponse<AgentSummary>>(`${BASE}/${agentId}`)),
  execute: (agentId: string, request: AgentExecutionRequest) =>
    callV3<AgentExecutionResponse>(
      api.post<ApiResponse<AgentExecutionResponse>>(`${BASE}/${agentId}/execute`, request),
    ),
};
